import { render, staticRenderFns } from "./WorkspaceGraphReminder.vue?vue&type=template&id=2431de44&scoped=true"
import script from "./WorkspaceGraphReminder.vue?vue&type=script&lang=js"
export * from "./WorkspaceGraphReminder.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGraphReminder.vue?vue&type=style&index=0&id=2431de44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431de44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2431de44')) {
      api.createRecord('2431de44', component.options)
    } else {
      api.reload('2431de44', component.options)
    }
    module.hot.accept("./WorkspaceGraphReminder.vue?vue&type=template&id=2431de44&scoped=true", function () {
      api.rerender('2431de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGraphReminder.vue"
export default component.exports